<template>
  <label
    :id="`${id}-label`"
    :for="id"
    :class="{ 'vertical-label': isVertical }"
    class="qlabel">
    {{ label }}
    <qx-info-icon
      v-if="infoIconId"
      :id="infoIconId"
      :position="infoIconPosition"
      :origin="infoIconOrigin"
      :title="infoIconTitle"
      :is-html="infoIconIsHtml" />
  </label>
</template>

<script>
import qxInfoIcon from '@/elements/infoIcon.vue';

export default {
  name: 'QxLabel',
  components: {
    qxInfoIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    infoIconId: {
      type: String,
      default: '',
    },
    infoIconTitle: {
      type: String,
      default: '',
    },
    infoIconPosition: {
      type: String,
      default: 'end center',
    },
    infoIconOrigin: {
      type: String,
      default: 'auto',
    },
    infoIconIsHtml: {
      type: Boolean,
      default: false,
    },
    isVertical: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.qlabel {
  color: $label-grey;
  font-weight: normal;
  line-height: 35px;
}
.vertical-label {
  margin-bottom: 0;
  line-height: 20px;
}
</style>
